export default __webpack_public_path__ + "static/media/HAL.438e75e2.png";